export default "__VITE_ASSET__DRw843Dw__"